"use client"
//Bar chart
import { Bar, BarChart, CartesianGrid, XAxis, YAxis, Legend, Tooltip, LabelList } from "recharts"

import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../../ui/card"
import {
  ChartContainer,
  ChartTooltipContent,
} from "../../../ui/chart"

const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

const chartConfig = {
  held: {
    label: "Clases Dictadas",
    color: "hsl(var(--chart-1))",
  },
  canceled: {
    label: "Clases Canceladas",
    color: "hsl(var(--chart-2))",
  },
  hourPlanned: {
    label: "Horas Planificadas",
    color: "hsl(var(--chart-3))",
  }
};

// Custom label for bars
const renderCustomBarLabel = ({ x, y, width, value }) => {
  return (
    <text 
      x={x + width / 2} 
      y={y - 5} 
      fill="#666" 
      textAnchor="middle"
      fontSize="12"
    >
      {value}
    </text>
  );
};

export default function Component({ data }) {
  const chartData = data.monthlyClassStats.map(stat => ({
    month: monthNames[stat.month - 1], // Convert month number to month name
    held: stat.classesHeld,
    canceled: stat.classesCanceled,
    hourPlanned: stat.hourPlanned
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Grafico de barras</CardTitle>
      </CardHeader>
      <CardContent>
        <ChartContainer config={chartConfig}>
          <BarChart 
            accessibilityLayer 
            data={chartData} 
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            height={350}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="month"
              tickLine={false}
              tickMargin={10}
              axisLine={false}
              tickFormatter={(value) => value.slice(0, 3)}
            />
            <YAxis 
              tickLine={false}
              axisLine={false}
              tickMargin={10}
            />
            <Legend 
              verticalAlign="top"
              height={36}
              wrapperStyle={{ paddingBottom: "10px" }}
            />
            <Tooltip
              content={<ChartTooltipContent indicator="dashed" />}
            />
            <Bar 
              dataKey="held" 
              fill="var(--color-held)" 
              radius={4}
              name="Clases Dictadas"
            >
              <LabelList dataKey="held" position="top" content={renderCustomBarLabel} />
            </Bar>
            <Bar 
              dataKey="canceled" 
              fill="var(--color-canceled)" 
              radius={4}
              name="Clases Canceladas"
            >
              <LabelList dataKey="canceled" position="top" content={renderCustomBarLabel} />
            </Bar>
            <Bar 
              dataKey="hourPlanned" 
              fill="var(--color-hourPlanned)" 
              radius={4}
              name="Horas Planificadas"
            >
              <LabelList dataKey="hourPlanned" position="top" content={renderCustomBarLabel} />
            </Bar>
          </BarChart>
        </ChartContainer>
      </CardContent>
      <CardFooter className="flex-col items-start gap-2 text-sm">
        <div className="flex gap-2 font-medium leading-none">
          Comparación entre clases dictadas, clases canceladas y horas planificadas
        </div>
      </CardFooter>
    </Card>
  )
}
